import { render, staticRenderFns } from "./joinNewsletterDialog.vue?vue&type=template&id=95aa3cac&scoped=true"
import script from "./joinNewsletterDialog.vue?vue&type=script&lang=js"
export * from "./joinNewsletterDialog.vue?vue&type=script&lang=js"
import style0 from "./joinNewsletterDialog.vue?vue&type=style&index=0&id=95aa3cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aa3cac",
  null
  
)

export default component.exports